import i18n, { use as i18nUse } from 'i18next'
import { initReactI18next } from 'react-i18next'

import { localeCodeMap, resources } from '~/locales'

export const initI18n = ({
  language,
  onLanguageChange,
}: {
  language: string
  onLanguageChange: (language: string) => void
}) => {
  i18nUse(initReactI18next).init({
    resources,
    fallbackLng: localeCodeMap.jaJp,
    lng: language,
    interpolation: {
      escapeValue: false,
    },
  })

  i18n.on('languageChanged', onLanguageChange)
}
